import React from 'react';
import { ownerVerifiedContent } from './contentConfig';

const DecisionScenariosV2 = () => {
  return (
    <section id="custos-riscos" className="py-16 md:py-24 bg-muted/30">
      <div className="container px-4 md:px-6 mx-auto max-w-6xl">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold tracking-tight md:text-4xl mb-6">
            “Sem juros” não significa “sem custo” e “aluguel” não significa “renda garantida”.
          </h2>
          <div className="text-left space-y-4 text-muted-foreground">
            <p>
              Em um consórcio, a comparação não deve parar na palavra “juros”. É necessário verificar taxa de administração, fundo de reserva, seguros, reajustes, regras de lance, custos de transferência, condições de desistência e demais encargos previstos no contrato. A contemplação depende das regras do grupo e não deve ser tratada como uma data garantida.
            </p>
            <p>
              Em um imóvel, o aluguel pode não cobrir parcela, impostos, condomínio, manutenção, seguros, vacância, inadimplência, custos de aquisição ou outros encargos. Qualquer exemplo deve mostrar essas premissas e também um cenário adverso.
            </p>
            <p className="font-medium text-foreground">
              Simulações são ilustrações condicionais. Elas não são promessa de rentabilidade, valorização, renda, economia ou aprovação.
            </p>
          </div>
        </div>

        <div className="overflow-x-auto rounded-lg border bg-card shadow-sm">
          <table className="w-full text-sm text-left">
            <thead className="bg-muted text-muted-foreground uppercase text-xs">
              <tr>
                <th className="px-6 py-4 font-semibold">Variável</th>
                <th className="px-6 py-4 font-semibold">Cenário favorável</th>
                <th className="px-6 py-4 font-semibold">Cenário-base</th>
                <th className="px-6 py-4 font-semibold">Cenário adverso</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              <tr>
                <td className="px-6 py-4 font-medium text-foreground">Contemplação</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR: hipótese contratual, sem prazo garantido]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
              </tr>
              <tr>
                <td className="px-6 py-4 font-medium text-foreground">Reajuste de parcela/crédito</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
              </tr>
              <tr>
                <td className="px-6 py-4 font-medium text-foreground">Vacância/inadimplência</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
              </tr>
              <tr>
                <td className="px-6 py-4 font-medium text-foreground">Manutenção, impostos e seguros</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
              </tr>
              <tr>
                <td className="px-6 py-4 font-medium text-foreground">Liquidez/saída</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
                <td className="px-6 py-4 text-muted-foreground">[CONFIRMAR]</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default DecisionScenariosV2;
